import { AxiosError } from "axios";


export default function getError (err: AxiosError){
    console.log({...err})
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore;
    return err?.response?.data?.message || err?.response?.message || err.response?.statusText || err.message || (typeof err.status === 'string' ? err.status : 'Something went wrong!')
}